module.exports = __webpack_public_path__ + "static/media/two.6dd8a2d8.jpg";